import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import { reloadForNewBuild } from "@/utils/lazyWithRetry";
import { isNewBuildWaiting } from "@/utils/newBuild";

/**
 * When a new build has been deployed since this tab was opened (utils/newBuild),
 * the next page change is a full load of that page -- on the new build -- rather
 * than an in-app one that would ask for files the deploy replaced. The URL has
 * already changed, so the reload lands exactly where the user was going.
 */
export const useLoadNewBuildOnNavigate = () => {
  const { pathname } = useLocation();
  const first = useRef(true);

  useEffect(() => {
    // Not on the first render: that is the page load itself.
    if (first.current) {
      first.current = false;
      return;
    }
    if (isNewBuildWaiting()) reloadForNewBuild();
  }, [pathname]);
};
